import { Box, HStack, Text } from "@chakra-ui/react";
import { convertDateFullTime } from "lib/utils/regular";
import SubTitle from "./SubTitle";

interface OrderInfoProps {
    reservationDate: number;
    phone: string;
    orderId: number;
}

const OrderInfo = (props: OrderInfoProps) => {
    const { reservationDate, phone, orderId } = props;
    console.log("reservationDate : ", reservationDate);

    return (
        <Box mx="20px">
            <SubTitle>주문정보</SubTitle>
            <HStack mb="0.5rem">
                <Text
                    fontSize="0.813rem"
                    fontWeight={"medium"}
                    color="#616161"
                    mr="2.8125rem"
                >
                    주문일시
                </Text>
                <Text fontSize="0.813rem" fontWeight={"medium"}>
                    {reservationDate
                        ? convertDateFullTime(reservationDate)
                        : ""}
                </Text>
            </HStack>
            <HStack mb="0.5rem">
                <Text
                    fontSize="0.813rem"
                    fontWeight={"medium"}
                    color="#616161"
                    mr="2.8125rem"
                >
                    전화번호
                </Text>
                <Text fontSize="0.813rem" fontWeight={"medium"}>
                    {phone}
                </Text>
            </HStack>
            <HStack mb="0.5rem">
                <Text
                    fontSize="0.813rem"
                    fontWeight={"medium"}
                    color="#616161"
                    mr="2.8125rem"
                >
                    주문번호
                </Text>
                <Text fontSize="0.813rem" fontWeight={"medium"}>
                    {orderId}
                </Text>
            </HStack>
        </Box>
    );
};

export default OrderInfo;
